// subscriptionExpired.js - recognise the backend's subscription gate response
// (WP7, AIT-291): HTTP 402 with {"detail": {"code": "subscription_expired"}}.

export const SUBSCRIPTION_EXPIRED_CODE = "subscription_expired";

export const isSubscriptionExpired402 = (status, data) =>
  status === 402 && data?.detail?.code === SUBSCRIPTION_EXPIRED_CODE;
